import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() { }
  generateExcel(data: any[], fileName: string): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Add headers
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);
    // Add data
    data.forEach((item) => {
      const row: any[] = [];
      headers.forEach((header) => {
        row.push(item[header]);
      });
      worksheet.addRow(row);
    });
    // Style the worksheet
    worksheet.getRow(1).font = { bold: true, size: 14 };
    //worksheet.getRow(1).fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: '#b6bec8' } };
    //worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.columns = [
      { header: 'NOME', key: 'NOME', width: 20 },
      { header: 'COGNOME', key: 'COGN', width: 20 },
      { header: 'AZIENDA', key: 'AZ', width: 40 },
      { header: 'EMAIL', key: 'EMAIL', width: 40 },
      { header: 'CONFERMATO', key: 'CONF', width: 20 }
    ];

    // Process each row for beautification
    worksheet.eachRow(function (row, rowNumber) {

      row.eachCell((cell, colNumber) => {
        if (rowNumber == 1) {
          // First set the background of header row
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'b6bec8' }
          }
        }
        // Set border of each cell
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        row.alignment = { vertical: 'middle', horizontal: 'center' };
      })
      //Process 'Balance Due' column for conditioning
      const _conf = worksheet.getColumn('CONF')
      // Iterate over all current cells in this column
      _conf.eachCell((cell, rowNumber) => {
        // If the balance due is 400 or more, highlight it with gradient color
        if (cell.value == "SI") {
          cell.fill = {
            type: 'gradient',
            gradient: 'angle',
            degree: 0,
            stops: [
              { position: 0, color: { argb: '6aed4c' } },
              { position: 0.5, color: { argb: '6aed4c' } },
              { position: 1, color: { argb: '6aed4c' } }
            ]
          };
        };
      });
      //Commit the changed row to the stream
      row.commit();
    });

    // Save the workbook to a blob
    let _dt = new Date().toJSON().slice(0,10)
    workbook.xlsx
      .writeBuffer()
      .then((buffer) =>
        saveAs(new Blob([buffer]), `${fileName} ${_dt}.xlsx`)
      )
      .catch((err) => console.log("Error writing excel export", err));

    //// Save the workbook to a blob
    //workbook.xlsx.writeBuffer().then((buffer) => {
    //  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //  saveAs(blob, `${fileName}.xlsx`);
    //});
  }
}
